// extracted by mini-css-extract-plugin
export default {"card":"ResourceConflictCard_card__wBPLM","title":"ResourceConflictCard_title__WJg+k","detail":"ResourceConflictCard_detail__IE7Qy"};